import { NewbuildingModal } from '@cian/frontend-newbuilding-sellers-info-components';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeSellersInfoModal } from '../../actions/sellersInfoModal';
import { selectSellersInfoModal } from '../../selectors/sellersInfoModal';

export const SellersInfoModalContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { isOpen } = useSelector(selectSellersInfoModal);

  const handleClose = React.useCallback(
    /* istanbul ignore next */
    () => {
      dispatch(closeSellersInfoModal());
    },
    [dispatch],
  );

  return <NewbuildingModal open={isOpen} onClose={handleClose} />;
};
